import { render } from "./prjCard.vue?vue&type=template&id=f4040122&scoped=true"
import script from "./prjCard.vue?vue&type=script&lang=js"
export * from "./prjCard.vue?vue&type=script&lang=js"

import "./prjCard.vue?vue&type=style&index=0&id=f4040122&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4040122"]])

export default __exports__